module.exports = __webpack_public_path__ + "static/caesarsLogo-b9e1b2385f9a80151b7e09fb3d30322e.png";